import { VersionStatus } from '@/generated/graphql'

export type LockableBop = {
  versionStatus: VersionStatus
  productConfiguration: { archived: boolean }
}

export function isBopLocked(bop: LockableBop | undefined): boolean {
  return bop?.versionStatus == VersionStatus.Released || !!bop?.productConfiguration.archived
}
